<template>
  <div class="large_main">
    <div class="top_title">
      <div class="title_text">电梯物联网管理平台</div>
      <div class="top_city">湖北省</div>
      <div class="top_info">
        <div class="tabs_box">
          <div
            :class="current == index ? 'tab_item active' : 'tab_item'"
            v-for="(item, index) in tabs"
            :key="index"
            @click="tabsChange(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="time_box">
          <div class="time">{{ time }}</div>
          <div class="admin" @click="goAdmin">
            <img class="admin_icon" src="@/assets/image/admin_icon.png" alt="" />
            管理后台
          </div>
        </div>
      </div>
    </div>
    <div class="large_content">
      <DataCenter v-if="current == 0" />,
      <MonitorCenter v-if="current == 1" />
    </div>
    <div class="large_bottom"></div>
  </div>
</template>

<script>
import DataCenter from "./dataCenter/index.vue";
import MonitorCenter from "./monitorCenter/index.vue";
export default {
  name: "ElevatorLargeIndex",
  components: {
    DataCenter,
    MonitorCenter,
  },
  data() {
    return {
      tabs: ["数据中心", "监控中心"],
      current: 0,
      time: "",
    };
  },
  mounted() {
    this.getTime();
  },

  methods: {
    goAdmin() {
      window.open("https://lift.yqdiot.cn/index");
      // window.open("http://192.168.0.104:731/index");
    },
    tabsChange(index) {
      this.current = index;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      // 根据本地化格式输出日期（中文）
      const localeFormattedDate = date.toLocaleString("zh-CN");
      return localeFormattedDate;
    },
    getTime() {
      this.getCurrentDateTime();
      setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },
    getCurrentDateTime() {
      let now = new Date();
      // 获取日期部分
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以要+1
      let day = now.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      // 获取星期部分
      let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let weekDay = weekDays[now.getDay()];
      // 组合成目标格式
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
  },
};
</script>
<style scoped lang="scss">
.large_main {
  // width: 1680px;
  // height: 1032px;
  position: relative;
  width: calc(100% - 40px);
  height: 100vh;
  background: url("@/assets/image/big_bg.png") no-repeat center;
  background-size: 100% 100%;
  padding: 0 20px;
  .top_title {
    background: url("@/assets/image/large_top_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 90px;
    position: relative;
    .title_text {
      width: 100%;
      text-align: center;
      padding-top: 6px;
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 40px;
      color: #fff;
      letter-spacing: 4px;
    }
    .top_city {
      background: url("@/assets/image/city_bg.png") no-repeat center;
      background-size: 100% 100%;
      width: 100px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: 16px;
      color: #fff;
      position: absolute;
      margin: auto;
      right: 24%;
      top: 10px;
    }
    .top_info {
      position: absolute;
      margin: auto;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tabs_box {
        margin-left: 60px;
        display: flex;
        height: 40px;
        .tab_item {
          height: 100%;
          width: 160px;
          line-height: 40px;
          cursor: pointer;
          text-align: center;
          margin-right: 40px;
          background: url("@/assets/image/tab_bg.png") no-repeat center;
          background-size: 100% 100%;
          font-family: YouSheBiaoTiHei;
          font-weight: 400;
          font-size: 26px;
          color: #7fa1b3;

          &.active {
            background: url("@/assets/image/tab_bg_a.png") no-repeat center;
            background-size: 100% 100%;
            color: #fff;
          }
        }
      }
    }
    .time_box {
      display: flex;
      margin-right: 40px;

      .time {
        font-weight: 700;
        font-size: 18px;
        color: #fff;
        margin-right: 30px;
      }

      .admin {
        width: 100px;
        height: 30px;
        box-sizing: border-box;
        background: rgba(94, 187, 253, 0.2);
        border-radius: 5px;
        border: 1px solid #78cbff;
        font-weight: 400;
        font-size: 14px;
        color: #82cfff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        line-height: 14px;
        .admin_icon {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }
      }
    }
  }

  .large_content {
    height: calc(100% - 154px);
  }

  .large_bottom {
    background: url("@/assets/image/large_bottom_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 44px;
  }
}
</style>
